import { localCalendarDay } from "./localCalendarDay";

export function branchTimezone(value) {
  const zone = value || "Asia/Kolkata";
  try { new Intl.DateTimeFormat("en-IN", { timeZone: zone }); return zone; }
  catch { return "Asia/Kolkata"; }
}

export function formatSlotTime(slot, timezone) {
  if (!slot?.start || Number.isNaN(new Date(slot.start).getTime())) return "";
  return new Intl.DateTimeFormat("en-IN", { timeZone: branchTimezone(slot.timezone || timezone), hour: "2-digit", minute: "2-digit", hour12: true }).format(new Date(slot.start));
}

export function formatSlotDateTime(slot, timezone) {
  if (!slot?.start || Number.isNaN(new Date(slot.start).getTime())) return "";
  return new Intl.DateTimeFormat("en-IN", { timeZone: branchTimezone(slot.timezone || timezone), day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }).format(new Date(slot.start));
}

export function formatAppointmentDateTime(appointment) {
  const zone = branchTimezone(appointment.clinic?.timezone || appointment.clinic_timezone || appointment.timezone);
  return `${formatSlotDateTime({ start: appointment.appointment_datetime }, zone)} (${zone})`;
}

export function slotDurationMinutes(slot) {
  const minutes = (new Date(slot?.end).getTime() - new Date(slot?.start).getTime()) / 60000;
  return Number.isFinite(minutes) && minutes > 0 ? minutes : null;
}

export function nextBranchCalendarDay(value, timezone) {
  const day = localCalendarDay(value, branchTimezone(timezone));
  if (!day) return "";
  const next = new Date(`${day}T00:00:00Z`);
  next.setUTCDate(next.getUTCDate() + 1);
  return next.toISOString().slice(0, 10);
}
